var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"additional-turnover",attrs:{"body-classes":"px-0"}},[_c('v-subscriptions',{attrs:{"customer_id":_vm.customer_id}}),_c('v-charges',{attrs:{"customer_id":_vm.customer_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }